import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Alert, Table, Modal } from 'react-bootstrap';
import axios from 'axios';

const AdminHomeForm = () => {
  const [title, setTitle] = useState('');
  const [homeList, setHomeList] = useState([]);
  const [editId, setEditId] = useState(null); // Track the home ID being edited
  const [showAlert, setShowAlert] = useState({ visible: false, type: '', message: '' });
  const [searchTerm, setSearchTerm] = useState(''); // Search filter for titles
  const [showModal, setShowModal] = useState(false); // Control modal visibility

  // Fetch homes by city on component mount
  useEffect(() => {
    fetchHomeList();
  }, []);

  const fetchHomeList = async () => {
    try {
      const response = await axios.get('https://api.biznetusa.com/api/get-searchbyhome');
      setHomeList(response.data.home_by_city);
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    setTitle(e.target.value);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSubmit = { title };

    try {
      // Add a new home title
      await axios.post('https://api.biznetusa.com/api/store-searchbyhome', formDataToSubmit);
      setShowAlert({ visible: true, type: 'success', message: 'Home title added successfully' });
      setTitle('');
      fetchHomeList(); // Refresh home list after submission
    } catch (error) {
      console.error(error);
      setShowAlert({ visible: true, type: 'danger', message: 'Failed to submit data' });
    }
  };

  const handleEdit = (home) => {
    setTitle(home.title);
    setEditId(home.id); // Track the ID for editing the title
    setShowModal(true); // Show the modal for editing
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const formDataToSubmit = { title };

    try {
      // Update existing home title
      await axios.put(`https://api.biznetusa.com/api/update-searchbyhome/${editId}`, formDataToSubmit);
      setShowAlert({ visible: true, type: 'success', message: 'Home title updated successfully' });
      setTitle('');
      setEditId(null);
      setShowModal(false); // Close modal after update
      fetchHomeList(); // Refresh home list after update
    } catch (error) {
      console.error(error);
      setShowAlert({ visible: true, type: 'danger', message: 'Failed to update data' });
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://api.biznetusa.com/api/deletesearchbyhome/${id}`);
      setShowAlert({ visible: true, type: 'success', message: 'Home title deleted successfully' });
      fetchHomeList(); // Refresh home list after deletion
    } catch (error) {
      console.error(error);
      setShowAlert({ visible: true, type: 'danger', message: 'Failed to delete home title' });
    }
  };

  // Filtered homes based on search term
  const filteredHomes = homeList.filter((home) =>
    home.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Container className="mt-5">
      {/* Center the Add New Home Title Section */}
      <Row className="justify-content-center">
        <Col md={8} lg={6} className="text-center mb-4">
          <h2 className="display-6">Add New Home Title</h2>
        </Col>
      </Row>

      {/* Form for Adding New Home Title */}
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          {showAlert.visible && (
            <Alert variant={showAlert.type} onClose={() => setShowAlert({ visible: false })} dismissible>
              {showAlert.message}
            </Alert>
          )}

          <Form onSubmit={handleSubmit} className="shadow p-4 rounded bg-white">
            <Form.Group controlId="formTitle">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter home title"
                value={title}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="mt-3 w-100">
              Submit New Title
            </Button>
          </Form>
        </Col>
      </Row>

      {/* Search and Table Section */}
      <Row className="justify-content-between mt-5">
        <Col>
          <h3 className="text-center">Existing Home Titles</h3>
        </Col>
        <Col md={4} className="text-right">
          <Form.Control
            type="text"
            placeholder="Search by title"
            value={searchTerm}
            onChange={handleSearchChange}
            className="shadow-sm"
          />
        </Col>
      </Row>

      {/* Table to display filtered homes */}
      
      <Row className="justify-content-center">
  <Col xs={12}>
    <Table
      striped
      bordered
      hover
      responsive="md"
      className="mt-3 table-bordered shadow-sm bg-white"
    >
      <thead className="thead-light">
        <tr>
          <th className="text-center">#</th>
          <th className="text-left">Title</th>
          <th className="text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        {filteredHomes.map((home, index) => (
          <tr key={home.id}>
            <td className="align-middle text-center">{index + 1}</td>
            <td className="align-middle text-left">{home.title}</td>
            <td className="align-middle text-center">
              <Button
                variant="info"
                className="mr-2 btn-sm"
                onClick={() => handleEdit(home)}
              >
                Edit
              </Button>
              <Button
                variant="danger"
                className="btn-sm"
                onClick={() => handleDelete(home.id)}
              >
                Delete
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </Col>
</Row>


      {/* Modal for updating the home title */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Home Title</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleUpdate}>
            <Form.Group controlId="formTitle">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter new home title"
                value={title}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="mt-3 w-100">
              Update Title
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default AdminHomeForm;
